module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-device/user-device.component.css
// module id = ./src/app/user-device/user-device.component.css
// module chunks = main